import React, { useEffect, useState } from 'react'
import moment from 'moment'

import { Grid, TextField as MuiTextField } from '@material-ui/core'

import { FilterProps } from './types'

export const DateTimeFilter = (props: FilterProps) => {
  const { label, defaultValue, onChange } = props
  const [value, setValue] = useState<moment.Moment>(defaultValue)

  useEffect(() => {
    if (!defaultValue) {
      setValue(defaultValue)
    }
  }, [defaultValue])

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <MuiTextField
          type="date"
          id={label}
          variant="standard"
          label={label}
          fullWidth
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const time = value ? value.format('HH:mm:ss') : '00:00:00'
            const newValue = moment(`${e.target.value} ${time}`)
            setValue(moment(newValue))
            onChange(newValue, newValue ? newValue.toISOString() : '')
          }}
          value={value ? value.format('YYYY-MM-DD') : ''}
        />
      </Grid>
      <Grid item xs={6}>
        <MuiTextField
          type="time"
          id={label}
          variant="standard"
          label={label}
          fullWidth
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const date = value ? value.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            const newValue = moment(`${date} ${e.target.value}`)
            setValue(newValue)
            onChange(newValue, newValue ? newValue.toISOString() : '')
          }}
          value={value ? value.format('HH:mm:ss') : ''}
        />
      </Grid>
    </Grid>
  )
}
